module.exports = __webpack_public_path__ + "static/media/vp_effortless.e5c9770b.svg";